export default {
    title: 'Nápověda',
    sideNavTitle: 'Obsah',
    sectionJumpPlaceholder: 'Skočit na sekci',
    sections: {
        intro: 'Vítejte',
        navigation: 'Orientace',
        dashboard: 'Dashboard',
        events: 'Události',
        ticketsets: 'Sady vstupenek',
        tickets: 'Vstupenky',
        devices: 'Zařízení',
        statistics: 'Statistiky',
        users: 'Uživatelé',
        permissions: 'Práva (IUR)',
        import: 'CSV import vstupenek',
        shortcuts: 'Klávesové zkratky',
        troubleshooting: 'Co dělat když',
        contact: 'Kontakt a hlášení chyb'
    },
    intro: {
        title: 'Vítejte',
        intro:
            'Bzuco Inspector je administrace pro správu vstupenek a jejich kontrolu na vstupech akcí. Tato nápověda popisuje, jak používat jednotlivé sekce. Aplikace běží paralelně se starou administrací na /admin/ — můžeš je mít otevřené současně a postupně přecházet.',
        points: [
            'Aplikace se přihlašuje stejnými údaji jako stará administrace.',
            'Data jsou sdílená — vstupenky importované zde uvidíš i ve starém adminu.',
            'Bzuco POS posílá automaticky sady vstupenek a akce, ručně se v této administraci nevytvářejí.'
        ]
    },
    navigation: {
        title: 'Orientace',
        intro:
            'Aplikace má tři hlavní oblasti: horní topbar s avatarem a drobečkovou navigací, levý sidebar se seznamem sekcí a hlavní obsahovou plochu. Sekce jsou seskupené podle smyslu: Přehledy, Vstupenky a Nastavení.',
        points: [
            'Topbar: klik na avatar (iniciály) → menu s odhlášením a přepnutím instance (pokud máš přístup k více).',
            'Drobečková navigace zobrazuje aktuální pozici v hierarchii — kliknutím se vrátíš zpět.',
            'Sidebar: skupiny Přehledy / Vstupenky / Nastavení. Klikem na položku se aplikace přepne do dané sekce.',
            'Globální zkratka: kdekoliv stiskni "/" — otevře filter bar (pokud sekce filtry má) a fokusne search input.',
            'Některé sekce vyžadují právo (Spravovat události, Statistiky, …) — bez práva se v menu ani nezobrazí.'
        ]
    },
    dashboard: {
        title: 'Dashboard',
        intro:
            'Domovská stránka po loginu. Slouží jako operativní přehled stavu — co se právě děje, kde je problém — ne jako analytický nástroj. Pro analytiku použij sekci Statistiky.',
        points: [
            'KPI karty: Validací za 24 h (se sparkline grafem), Vstupenky (used/total), Aktivní zařízení, Akce ±7 dní. Zobrazují se podle tvých práv.',
            'Aktivní akce (max 3): nejprve ongoing dnes, pak nadcházející, nakonec nedávno skončené.',
            'Poslední scany: 20 posledních úspěšných validací z TicketUsageLog.',
            'Upozornění: 3 typy — DEVICE_OFFLINE (zařízení mlčí > 2 h během eventu), EVENT_NO_SCANS (event startuje za < 24 h a má 0 validací), BROKEN_TICKETSET (sada bez ceny — nelze skenovat).',
            'Rychlé akce: import vstupenek, založení události, založení zařízení.',
            'Auto-refresh 60 s + manuální tlačítko vpravo nahoře. Při skrytém tabu se polling automaticky pauzuje, aby šetřil baterii.',
            'Superuser navíc vidí tabulku všech instancí; klik na řádek přepne aktivní instanci.'
        ]
    },
    events: {
        title: 'Události',
        intro:
            'Seznam akcí napojených na Bzuco POS. Klikem na řádek se otevře expand-panel s editací. Pole, která chodí ze synchronizace (název, datumy), lze editovat — ID a Bzuco ID jsou read-only.',
        points: [
            'Filtr: search (název) + status (upcoming / live / ended). Status se počítá klient-side z startAt a endAt.',
            'Bulk-select + bulk-delete: backend nemá deleteMulti, takže mazání probíhá v loopu přes Promise.allSettled — jednotlivé chyby tě nezablokují.',
            'Akce vznikají v Bzuco POS a do administrace přicházejí sync procesem. Tady je můžeš upravit, ale nelze založit úplně novou akci bez POS.'
        ]
    },
    ticketsets: {
        title: 'Sady vstupenek',
        intro:
            'Sady vstupenek (ticketsets) jsou skupiny vstupenek se stejným typem (např. „Vstupenka VIP"). Sady se vytvářejí v Bzuco POS, do administrace přicházejí ze synchronizace. V této sekci je možné jen editovat název a flag „validovat", celé sady se nezakládají.',
        points: [
            'Expand-panel má 3 sekce: Editovat (name, customName, validate flag), Metadata (read-only datumy, ID, Bzuco ID), Cenové hladiny (read-only sub-tabulka).',
            'Klik na sloupec „Akce" → proklik na /tickets?ticketset=<id> — uvidíš jen vstupenky té konkrétní sady.',
            'Pokud sada chybí, zkontroluj sync z Bzuco POS — sada musí dorazit, jinak se k ní vstupenky nepřiřadí.'
        ]
    },
    tickets: {
        title: 'Vstupenky',
        intro:
            'Hlavní datová sekce — typicky obsahuje tisíce položek. Používá cursor pagination s volbou 50 / 100 / 200 vstupenek na stránku a zobrazuje "1–N z total". Klik na řádek otevře expand-panel s editací.',
        points: [
            'Filtry: search (kód / jméno / email / telefon), event (s vyhledáváním v selectu), ticketset, používání (3-state: Ano / Ne / oboje).',
            'Filtry se synchronizují s URL query stringem (debounced 300 ms) — link jde sdílet a zachová stav.',
            'Bulk-select + bulk-delete. CSV export aktuální stránky.',
            'Import CSV: tlačítko vede na /tickets/import — wizard 4 kroků (upload → preview → mapování → potvrzení). Více v sekci „CSV import vstupenek".',
            'Globální "/" shortcut otevře filter bar a fokusne search input.'
        ]
    },
    devices: {
        title: 'Zařízení',
        intro:
            'Zařízení jsou mobilní scannery (PDA, telefon s aplikací), které validují vstupenky na vstupu. Plný CRUD — můžeš zařízení založit, upravit i smazat.',
        points: [
            'Create/Edit dialog obsahuje pole name, username, password. Username je unikátní login pro scanner.',
            'Při editaci nech heslo prázdné, pokud ho nechceš měnit — neukládá se prázdná hodnota.',
            'Filter: search prohledává name i username.',
            'Bulk-select + bulk-delete funguje stejně jako u událostí (Promise.allSettled).'
        ]
    },
    statistics: {
        title: 'Statistiky',
        intro:
            'Analytický nástroj pro vyhodnocení akcí, sad a zařízení. Vyžaduje právo „Statistiky" — bez něj se sekce v menu nezobrazí.',
        points: [
            'Filtr-card (sbalitelný): události multi-select, zařízení multi-select, dateFrom / dateTo, interval (auto / day / hour / minute), zobrazit prázdné sady.',
            'Manuální „Zobrazit" trigger — žádný auto-refetch při změně filtru. Nastav vše a teprve pak spusť.',
            'KPI nahoře: Zkontrolováno (count + procento) a Celkem.',
            'Tabulka sum per sada s expandable sub-tabulkou (per cenová hladina) a grand totalem na konci.',
            'Graf: ApexCharts area chart s validacemi v čase, jedna křivka per zařízení. Layout dvou sloupců.',
            'Deprecated checkpointy jsou klient-side odfiltrované — v datech existují, ale do grafu/sum se nezapočítávají.'
        ]
    },
    users: {
        title: 'Uživatelé',
        intro:
            'Seznam uživatelů systému. Klikem na řádek se otevře expand-panel se třemi sekcemi: Editovat profil, Práva matrix (per-instance) a Metadata. Editace práv probíhá per řádek (per IUR — viz sekce Práva).',
        points: [
            'Backend rozšířen o admin.user.updateRights(userId, instanceId, …) — to umožňuje upravit práva uživatele v dané instanci, i kdyby to nebyla jeho primární.',
            'Username, heslo a primární instance jsou v UI skryté — chráníme Bzuco sync, abys omylem nerozhodil propojení.',
            'Neaktivní uživatelé jsou ztlumení (opacity-50), takže rovnou vidíš, kdo se nepřihlašuje.',
            'Per-řádek dirty indicator: dokud práva neuložíš tlačítkem „Uložit", změny zůstávají lokální.'
        ]
    },
    permissions: {
        title: 'Práva (IUR)',
        intro:
            'Práva v Bzuco Inspectoru jsou per-instance (IUR = Instance User Role). Jeden uživatel může mít v každé instanci jiná práva — typicky admin v jedné, čtenář v druhé.',
        points: [
            'Seznam práv: Spravovat uživatele, Spravovat události, Spravovat sady vstupenek, Spravovat vstupenky, Spravovat zařízení, Statistiky.',
            'Superuser má všechna práva implicitně — hasRight() pro něj vždycky vrátí true, bez ohledu na IUR záznamy.',
            'Pokud někdo nevidí očekávanou sekci v menu, prvním krokem je zkontrolovat jeho IUR v sekci Uživatelé.',
            'Změna práv se aplikuje na další request — uživatel nemusí být odhlášen.'
        ]
    },
    import: {
        title: 'CSV import vstupenek',
        intro:
            'Hromadný import vstupenek probíhá přes wizard /tickets/import. Wizard má 4 kroky: upload souboru → preview s validací → mapování polí → potvrzení a odeslání na backend.',
        points: [
            'Akceptovaný formát: CSV s 17 sloupci jako poziční array. Hlavičky v češtině (Číslo vstupenky, ID ceny, …) jsou tolerovány.',
            'Preview zobrazí prvních 14 viditelných sloupců + statistiku unikátních sad a cenových hladin v souboru.',
            'Vstupenky se přiřazují ke ticketsetům podle prefixu kódu — sada musí v systému existovat (přijde z Bzuco POS) ještě před importem.',
            'Pokud import projde, ale všechna pole jsou NULL, je obvykle chyba ve formátu CSV — viz „Co dělat když".'
        ]
    },
    shortcuts: {
        title: 'Klávesové zkratky',
        intro:
            'Aplikace má minimum zkratek navíc oproti prohlížeči — záměrně, aby nepřekážely.',
        points: [
            '"/" — otevři filter bar (pokud existuje) a fokusne search input. Funguje na Vstupenkách, Statistikách a dalších filterovaných sekcích.',
            'Tab / Shift+Tab — standardní procházení formulářových polí.',
            'Esc — zavře otevřený dialog nebo expand-panel (kde to dává smysl).',
            'Standardní browser zkratky fungují normálně (Ctrl/Cmd+F pro hledání v aktuálně vykresleném obsahu apod.).'
        ]
    },
    troubleshooting: {
        title: 'Co dělat když',
        intro:
            'Seznam nejčastějších problémů a jejich řešení. Pokud nic z toho nepomůže, viz „Kontakt a hlášení chyb".',
        points: [
            'Nevidím sekci v menu — chybí ti právo. Požádej administrátora o úpravu IUR (sekce Uživatelé → Práva matrix).',
            'Vstupenky neimportují / všechna pole jsou NULL — CSV nemá správný formát. Backend čte poziční array, ne mapu. Zkontroluj, že hlavička sedí (i v češtině) a exportér nepřidává sloupce navíc.',
            '„Aktualizováno před X s" ukazuje 0 nebo -1 — opraveno ve v0.7.0. Pokud stále vidíš -1, restartuj stránku (F5).',
            'Po přepnutí instance vidím stará data — composable nezachytil invalidationKey. Refresh stránky (F5) problém vyřeší. Hlas, pokud se opakuje.',
            'Scanner offline alert i když zařízení skenuje — TicketUsageLog musí být v intervalu < 1 h. Pokud scanner skenuje, ale validace se neukládají, je problém na backendu — kontaktuj Lukáše.'
        ]
    },
    contact: {
        title: 'Kontakt a hlášení chyb',
        intro:
            'Bzuco Inspector je interní single-dev projekt. Pokud najdeš chybu nebo máš návrh, ozvi se přímo.',
        points: [
            'Issue tracker: interní (bzuco_inspector_admin) — popiš co se stalo, co jsi čekal a co aplikace ukázala.',
            'Pro kritické chyby (validace nejdou, data se ztrácí, login nefunguje) kontaktuj přímo Lukáše.',
            'Při hlášení přilož screenshot a URL — značně to urychlí diagnostiku.'
        ]
    }
}
